import SecondarySearchBar from './SecondarySearchBar';

export default SecondarySearchBar;
